
// export const Table = () => <table />

// {...props} ref={(el) => {
//   if (el) el['cal'] = forRef
// }}

const MONTHS = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль',
 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']

export function getMonth(idx, months = MONTHS) {
 // const date = new Date()
 const month = months[idx]

 // var locale = "en-us",
 //   month = objDate.toLocaleString(locale, { month: "long" })

 return month
}


/**
 * Creates a 2D array with dates for the given month.
 * @param {Object} param
 * @param {!Date} [param.today] The year.
 * @param {number} param.year The year.
 * @param {number} param.month The month.
 * @param {Date|boolean} param.disablePast Don't show before this date.
 */
export const makeCal = ({
 today = new Date(),
 year = today.getFullYear(),
 month = today.getMonth(),
 disablePast = false,
} = {}) => {
 const TODAY_DATE = today.getDate()
 let i = 1
 let day = new Date(year, month, i)
 const m = day.getMonth()
 const cal = []
 let row = null
 while (day.getMonth() == m) {
  if (!row) row = Array.from({ length: 7 }).map(() => '-')
  const d = (day.getDay() || 7) - 1
  const date = day.getDate()
  if (disablePast && (date <= TODAY_DATE)) {
   row[d] = `-${date}`
  } else {
   row[d] = `${date}`
  }
  if (d == 6) {
   cal.push(row)
   row = null
  }
  i++
  day = new Date(year, month, i)
 }
 if (row) cal.push(row)
 return cal
}